import { useEffect } from "react";
import { SITE } from "../data/site";

const setMeta = (attr, key, content) => {
    let el = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
};

export const Seo = ({ title, description, path = "/", keywords, jsonLd = [] }) => {
    const url = `${SITE.domain}${path}`;
    const jsonLdKey = JSON.stringify(jsonLd);

    useEffect(() => {
        document.title = title;
        setMeta("name", "description", description);
        setMeta("property", "og:title", title);
        setMeta("property", "og:description", description);
        setMeta("property", "og:url", url);
        setMeta("name", "twitter:title", title);
        setMeta("name", "twitter:description", description);

        let canonical = document.head.querySelector('link[rel="canonical"]');
        if (!canonical) {
            canonical = document.createElement("link");
            canonical.rel = "canonical";
            document.head.appendChild(canonical);
        }
        canonical.href = url;

        if (keywords) {
            let kw = document.head.querySelector('meta[name="keywords"]');
            if (!kw) {
                kw = document.createElement("meta");
                kw.name = "keywords";
                document.head.appendChild(kw);
            }
            kw.setAttribute("content", keywords);
        }

        document.head
            .querySelectorAll("script[data-seo-jsonld]")
            .forEach((s) => s.remove());
        JSON.parse(jsonLdKey).forEach((obj) => {
            const s = document.createElement("script");
            s.type = "application/ld+json";
            s.setAttribute("data-seo-jsonld", "true");
            s.textContent = JSON.stringify(obj);
            document.head.appendChild(s);
        });
    }, [title, description, url, keywords, jsonLdKey]);

    return null;
};
